<template style="background-color: white;">
    <div style="background-color: white; line-height: 1.7em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <span v-for="data,index in marksheet_data" :key="index">
            <div class="d-flex" style="height: 100vh; margin-top: -5px;">
                <div style="border: 15px solid transparent; flex: 100%; background-color: transparent; height: 100%;">
                    <div style="flex: 100%; background-color: #ccccff; width: 97.56vw;">
                        <div class="d-flex" style="height: 97.5vh;">
                            <div style="border-right: 25px solid #5229cc !important; border: 25px solid #5229cc; background-color: #ccccff; flex: 50%; display: flex; align-items: center; justify-content: center;">
                                <div class="row">
                                    <div class="col-12">
                                        <center>
                                            <table style="width: 90%; border-collapse: collapse;">
                                                <tr v-for="g,index in data.remarks_list" :key="index">
                                                    <th style="width: 30%;">
                                                        <!-- {{ g.symbol }} -->
                                                        <img class="svg-content" :src="g.symbol" alt="" width="12%" />
                                                    </th>
                                                    <th style="width: 30%; font-size: 120%; text-align: left; font-weight: bold;" class="pl-2"><strong>{{ g.remark }}</strong></th>
                                                </tr>
                                            </table>
                                        </center>
                                    </div>
                                    <div class="col-12">
                                        <center>
                                            <center><strong>GRADE KEY </strong></center>
                                            <table class="grade-table" style="width: 90%; border: none;">
                                                <tr>
                                                    <td style="width: 48%; vertical-align: top; text-align: left;">
                                                        <table style="width: 100%; border-collapse: collapse;">
                                                            <tr v-for="(g, index) in data.grade_details.slice(0, Math.ceil(data.grade_details.length / 2))" :key="g.id" v-if="g.gradename != '-'">
                                                                <th class="first-col" style="width: 20%; font-size: 120%; padding-left: 25px; font-weight: bold;">{{ g.gradename }}</th>
                                                                <th style="width: 40%; font-size: 120%; text-align: center; font-weight: bold;">{{ g.range }}</th>
                                                                <th style="font-size: 120%; text-align: center; width: 40%; font-weight: bold;"><strong>{{ g.graderemark }}</strong></th>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                    <td class="blank-td" style="width: 4%; vertical-align: top; border: none !important;"></td>
                                                    <td style="width: 48%; vertical-align: top; text-align: left;">
                                                        <table style="width: 100%; border-collapse: collapse;">
                                                            <tr v-for="(g, index) in data.grade_details.slice(Math.ceil(data.grade_details.length / 2), data.grade_details.length)" :key="g.id" v-if="g.gradename != '-'">
                                                                <th class="first-col" style="width: 20%; font-size: 120%; padding-left: 25px; font-weight: bold;">{{ g.gradename }}</th>
                                                                <th style="width: 40%; font-size: 120%; text-align: center; font-weight: bold;">{{ g.range }}</th>
                                                                <th style="font-size: 120%; width: 40%; text-align: center; font-weight: bold;"><strong>{{ g.graderemark }}</strong></th>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </center>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-5" style="border-left: 25px solid #5229cc !important; border: 25px solid #5229cc; background-color: #ccccff; flex: 50%;">
                                <span style="text-transform: uppercase; font-size: xx-large; font-weight: bolder; color: #450676;"> <center>{{ data.org_basic_data.trust_name }}</center> </span>
                                <span style="color: #450676;"><center>{{ data.org_basic_data.address }}</center></span>
                                <center><img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/logo/WWS_Logo-01.png" width="120px" height="120px" alt="logo" /></center>
                                <center>
                                    <div style="border: 5px solid #5229cc; width: 420px; height: 320px;"><img :src="data.marksheet_img" alt="" width="400px" height="300px" class="mt-1" style="border: 2px solid #5229cc;" /></div>
                                </center>
                                <br />
                                <span style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"> <center>Report Card</center> </span> <br />
                                <div class="row pl-5" style="text-transform: uppercase; font-size: large; font-weight: bolder; margin-top: -25px;">
                                    <div class="col-12 mt-2 pt-2">
                                        <div class="row">
                                            Name :
                                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                                <span v-if="data.name_as_on_aadhar_card!='' && data.name_as_on_aadhar_card!=null">{{ data.name_as_on_aadhar_card }}</span>
                                                <span v-else>{{ data.name }} <span class="pl-1"></span> {{ data.sur_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6"><div class="row">std : {{ data.standard }}</div></div>
                                    <div class="col-6"><div class="row">Div : {{ data.div }}</div></div>
                                </div>
                                <div class="mt-2 pt-2" style="text-transform: uppercase; font-size: x-large; font-weight: bolder;"><center>{{data.ay}}</center></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex pagebreak pl-5 pt-5" style="height: 100vh; width: 98vw;">
                <div style="border: 15px solid transparent; flex: 100%; background-color: transparent; height: 100%;">
                    <div style="flex: 100%; height: 94.5vh;">
                        <div class="d-flex" style="">
                            <div style="flex: 50%;">
                                <div class="row" style="margin-top: -15px;">
                                    <div class="col-10" style="margin-bottom: -10px;">
                                        <b style="font-size: 15px;">
                                            Student Name: <span v-if="data.name_as_on_aadhar_card!='' && data.name_as_on_aadhar_card!=null">{{ data.name_as_on_aadhar_card }}</span> <span v-else>{{ data.name }} {{ data.sur_name }}</span>
                                        </b>
                                    </div>
                                    <div class="col-2" style="margin-bottom: -10px;"><b style="font-size: 15px;"> 1st Term </b></div>
                                </div>
                            </div>
                            <div style="flex: 50%;">
                                <div class="row" style="margin-top: -2px;">
                                    <b style="font-size: 15px; margin-bottom: -10px; margin-left: 25px;"> 2nd Term </b>
                                    <b style="font-size: 15px; margin-left: 130px; margin-bottom: -10px;"> Roll No.: {{ data.roll_no }} </b>
                                    <b style="font-size: 15px; margin-left: 100px; margin-bottom: -10px;"> Class: {{ data.standard }} </b>
                                    <b style="font-size: 15px; margin-left: 20px; margin-bottom: -10px;"> Div: {{ data.div }} </b>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="">
                            <div class="table_container_data mr-5" style="flex: 50%; line-height: 1.7em; margin-left: 10px;">
                                <table v-for="datam,index1 in data.leraner_marksheet" :key="index1" style="height: 300px;">
                                    <thead>
                                        <tr>
                                            <th class="td_width" colspan="2" v-if="index1==0" style="height: 45px; width: 400px;">
                                                <div>Marks out of 100</div>
                                                <div style="margin-top: -15px;">
                                                    Pass Marks for each subject is 33%
                                                </div>
                                            </th>
                                            <th colspan="3" style="width: 300px; height: 45px;" class="pl-2 pr-2">
                                                {{data.ass_type_term_1[index1]}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th v-if="index1==0" colspan="2"></th>
                                            <th style="width: 130px;">Marks</th>
                                            <th style="width: 50px;">Comment</th>
                                        </tr>
                                        <tr v-for="s, index in datam" :key="index">
                                            <td colspan="2" v-if="s[0].credit == 0 && index1==0" style="text-transform: uppercase;" class="pl-2">
                                                <strong>
                                                    {{ index }}
                                                    <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks }}</span>
                                                </strong>
                                            </td>
                                            <td v-if="s[0].credit != 0 && index1==0" style="text-transform: uppercase; width: 35% !important;" class="pl-2">
                                                <strong>
                                                    {{ index }}
                                                    <span v-if="s[0].sub_marks < 100 || s[0].sub_marks > 100">{{ s[0].crs_marks }}</span>
                                                </strong>
                                            </td>
                                            <td style="width: 10% !important;" v-if="s[0].credit != 0 && s[0].count != 0 && index1==0" :rowspan="s[0].count">
                                                <v-row dense>
                                                    <span class="avg" style="margin-left: -10px; margin-top: -2px;">
                                                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/wws_wakad_marksheet_img/curly_ca.svg" />
                                                    </span>
                                                </v-row>
                                            </td>
                                            <td style="font-size: 12px; width: 20%;">
                                                <center>
                                                    <strong>
                                                        {{ s[0].marks }}
                                                    </strong>
                                                </center>
                                            </td>
                                            <td style="height: 30px; width: 55px; font-size: 12px; width: 5%;">
                                                <center>
                                                    <strong>
                                                        <!-- {{ s[0].comment }} -->
                                                        <img class="svg-content_crs" :src="s[0].comment" alt="" width="80%" />
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-2" colspan="2" v-if="index1==0">
                                                <strong>ATTENDANCE</strong>
                                            </td>
                                            <td class="diagonalCross2">
                                                <span style="position: relative; font-size: 12px;" v-for="at,ind in data.attendance_list_sem_1[index1]" :key="ind">
                                                    <span class="pl-2" style="position: relative; left: 20%; top: -5px;">
                                                        <strong>
                                                            {{ at.present }}
                                                        </strong>
                                                    </span>
                                                    <span class="pt-2" style="position: absolute; left: 250%;">
                                                        <strong>
                                                            {{ at.total_working_stud }}
                                                        </strong>
                                                    </span>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="pl-2" colspan="2" v-if="index1==0">
                                                <strong>TOTAL </strong>
                                            </td>
                                            <td class="diagonalCross2" style="font-size: 12px;">
                                                <span style="position: relative;" v-if="data.ass_type_hide_show_percentage[index1]">
                                                    <span class="pl-1" style="position: relative; left: 20%; top: -5px;">
                                                        <strong>
                                                            {{ data.total_marks_ass_type[index1] }}
                                                        </strong>
                                                    </span>
                                                    <span class="pt-2" style="position: absolute; left: 200%;">
                                                        <strong>
                                                            {{ data.out_off_marks_ass_type[index1] }}
                                                        </strong>
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <center>
                                                        <strong> - </strong>
                                                    </center>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="pl-2" colspan="2" v-if="index1==0">
                                                <strong>PERCENTAGE </strong>
                                            </td>
                                            <td style="font-size: 12px;">
                                                <span v-if="data.ass_type_hide_show_percentage[index1]">
                                                    <center>
                                                        <strong>
                                                            {{ data.percentage_list_ass_type[index1] }}
                                                        </strong>
                                                    </center>
                                                </span>
                                                <span v-else>
                                                    <center>
                                                        <strong> - </strong>
                                                    </center>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="pl-2" colspan="2" v-if="index1==0" style="line-height: 130%;">
                                                <strong>TEACHER ISSUING THE REPORT CARD </strong>
                                            </td>
                                            <td style="font-size: 12px;" :colspan="data.display_flag_avg == true ? 3 : 2">
                                                <center>
                                                    <strong>
                                                        {{ data.inst_name }}
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table_container_data ml-5 mr-3" style="flex: 50%; line-height: 1.7em;">
                                <table v-for="datam,index1 in data.leraner_marksheet_sem_2" :key="index1" style="height: 300px;">
                                    <thead>
                                        <tr>
                                            <th colspan="3" style="width: 300px; height: 45px;">
                                                {{data.ass_type_term_2[index1]}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th style="width: 130px;">Marks</th>
                                            <th style="width: 50px;">Comment</th>
                                        </tr>
                                        <tr v-for="s, index in datam" :key="index">
                                            <td style="font-size: 12px;">
                                                <center>
                                                    <strong>
                                                        {{ s[0].marks }}
                                                    </strong>
                                                </center>
                                            </td>
                                            <td style="height: 30px; width: 50px; font-size: 12px;">
                                                <center>
                                                    <strong>
                                                        <!-- {{ s[0].comment }} -->
                                                        <img class="svg-content_crs" :src="s[0].comment" alt="" width="80%" />
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="diagonalCross2">
                                                <span style="position: relative; font-size: 12px;" v-for="at,ind in data.attendance_list_sem_2[index1]" :key="ind">
                                                    <span class="pl-2" style="position: relative; left: 20%; top: -5px;">
                                                        <strong>
                                                            {{ at.present }}
                                                        </strong>
                                                    </span>
                                                    <span class="pt-2" style="position: absolute; left: 250%;">
                                                        <strong>
                                                            {{ at.total_working_stud }}
                                                        </strong>
                                                    </span>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="diagonalCross2">
                                                <span style="position: relative; font-size: 12px;" v-if="data.ass_type_hide_show_percentage_sem_2[index1]">
                                                    <span class="pl-2" style="position: relative; left: 20%; top: -5px;">
                                                        <strong>
                                                            {{ data.total_marks_ass_type[index1+2] }}
                                                        </strong>
                                                    </span>
                                                    <span class="pt-2" style="position: absolute; left: 230%;">
                                                        <strong>
                                                            {{ data.out_off_marks_ass_type[index1+2] }}
                                                        </strong>
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <center>
                                                        <strong> - </strong>
                                                    </center>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 12px;">
                                                <span v-if="data.ass_type_hide_show_percentage_sem_2[index1]">
                                                    <center>
                                                        <strong>
                                                            {{ data.percentage_list_ass_type[index1+2] }}
                                                        </strong>
                                                    </center>
                                                </span>
                                                <span v-else>
                                                    <center>
                                                        <strong> - </strong>
                                                    </center>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 12px;" :colspan="data.display_flag_avg == true ? 3 : 2">
                                                <center>
                                                    <strong>
                                                        {{ data.inst_name }}
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--overall data table-->
                                <table style="width: 50%;">
                                    <thead>
                                        <tr>
                                            <th colspan="3" style="height: 45px; width: 300px;">
                                                <div v-if="org_id=='1'">Overall Average of Unit 1-4</div>
                                                <div v-else>Overall Average</div>
                                                <div style="margin-top: -15px;">{{ data.ay }}</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th style="width: 130px;">Marks</th>
                                            <th style="width: 50px;">Comment</th>
                                        </tr>
                                        <tr v-for="ov, index in data.overall_data" :key="index">
                                            <td style="font-size: 12px;">
                                                <center>
                                                    <strong>
                                                        {{ ov.marks }}
                                                    </strong>
                                                </center>
                                            </td>
                                            <td style="height: 30px; width: 50px; font-size: 12px;">
                                                <center>
                                                    <strong>
                                                        <!-- {{ov.comment}} -->
                                                        <img class="svg-content_crs" :src="ov.comment" alt="" width="80%" />
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="diagonalCross2">
                                                <span style="position: relative; font-size: 12px;">
                                                    <span v-if="data.display_overall_total">
                                                        <strong>
                                                            <span style="position: relative; left: 25%; top: -5px;">
                                                                {{ data.attendance_list_overall[0].present }}
                                                            </span>
                                                            <span class="pt-2 ml-5" style="position: absolute; left: 250%;">
                                                                {{ data.attendance_list_overall[0].total_working_stud }}
                                                            </span>
                                                        </strong>
                                                    </span>
                                                    <span v-else>
                                                        <strong>
                                                            <span style="position: relative; left: 10%; top: -5px;">
                                                                -
                                                            </span>
                                                            <span class="pt-2 ml-5" style="position: absolute; left: 500%;">
                                                                -
                                                            </span>
                                                        </strong>
                                                    </span>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td class="diagonalCross2">
                                                <span style="position: relative; font-size: 12px;">
                                                    <strong>
                                                        <span style="position: relative; left: 10%; top: -5px;">
                                                            -
                                                        </span>
                                                        <span class="pt-2 ml-5" style="position: absolute; left: 500%;">
                                                            -
                                                        </span>
                                                    </strong>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 12px;">
                                                <span v-if="data.show_hide_avg_overall">
                                                    <center>
                                                        <strong>
                                                            {{ data.percentage }}
                                                        </strong>
                                                    </center>
                                                </span>
                                                <span v-else>
                                                    <center>
                                                        <strong> - </strong>
                                                    </center>
                                                </span>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 12px;" :colspan="data.display_flag_avg == true ? 3 : 2">
                                                <center>
                                                    <strong>
                                                        {{ data.inst_name }}
                                                    </strong>
                                                </center>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="d-flex" style="">
                            <div style="flex: 100%;">
                                <div class="row pl-2 pr-5 mt-2 pt-2" style="margin-left: 0.1px; height: 35px;">
                                    <div style="font-size: 13px; font-family: 'Times New Roman', Times, serif; line-height: 130%;">
                                        <strong>General Remark: </strong>
                                        <span>{{ data.marksheet_remark }} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <v-row dense class="pt-2">
                        <v-col cols="12" sm="3" md="3" class="pl-5 pt-5">
                            <div>
                            <b>Promoted To : </b>
                                <span style="border-bottom: 1px solid; display: inline-block; width: 70px;">{{ data.next_std }}
                                    <span  v-if="org_id=='1'">-{{ data.next_div }}</span>
                                </span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" style="margin-left: -50px;" >
                            <div v-if="data.standard == 'III'" class="pt-1">
                                <strong> Initiated into__________________ House </strong>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="5" md="5" class="pl-9" align="center">
                            <div v-if="org_id=='1'"  style="display: flex; align-items: center;">
                            <strong>Principal's Signature</strong>
                                <span style=" display: inline-block;align-items: center; width: 190px;text-align: left;" >
                                        <img style="margin-bottom: -13px;" class="pl-2"  src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="110px" height="45px" alt="logo" /> 
                                </span>
                            </div>
                            <div v-else>
                            <strong>Principal's Signature</strong>
                                <span style="border-bottom: 1px solid black; display: inline-block;align-items: center; width: 190px;text-align: left;" >
                                        <img style="margin-top: -16px; margin-bottom: -13px;" class="pl-2" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/2/chatgptimagesep22,2026,10_28_47amkz4i3o070g.png" width="110px" height="45px" alt="logo" /> 
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                        <!-- <div class="d-flex" style="">
                            <div style="flex: 70%;" class="ml-4 mt-2 pt-2">
                                <div class="row">
                                    <strong>Promoted To : </strong>
                                    <div style="width: 20%; margin-left: 5px;" class="stud_details2">
                                        {{ data.next_std }}
                                        <span v-if="org_id=='1'">-{{ data.next_div }}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 40%;" class="mt-2 pt-2">
                                <div class="row">
                                    <strong>Principal's Signature</strong>
                                    <div style="width: 45%; margin-left: 5px;" class="stud_details2">
                                        <strong>
                                            <img style="margin-top: -16px;" v-if="org_id=='1'" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/wakad-removebg.png" width="100px" height="45px" alt="logo" />
                                            <img
                                                style="margin-top: -16px;"
                                                v-else
                                                src="https://eduplusschool.s3.ap-south-1.amazonaws.com/wws/principal_sign/Ma_am_sign_for_Report_Card_1-removebg-preview%2B(1).png"
                                                width="100px"
                                                height="45px"
                                                alt="logo"
                                            />
                                        </strong>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            
        </span>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                sel_std: null,
                sel_div: null,
                show_hide_percentage: null,
                marksheet_data: [],
            };
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.show_hide_percentage = localStorage.getItem("show_hide_percentage");
            this.sel_std = localStorage.getItem("setstd");
            this.sel_div = localStorage.getItem("setdiv");
            this.org_id = localStorage.getItem("EPS-org-id");
            this.onload();
        },
        methods: {
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                const data = {
                    ay: this.sel_ay_data,
                    std: this.sel_std,
                    div: this.sel_div,
                    show_hide_percentage: this.show_hide_percentage,
                };
                this.overlay = true;
                axios
                    .post("/WWSExamination/getBulkAnnualMarkseetData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.marksheet_data = res.data.data;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.smsg); // show snackbar
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
        },
    };
</script>

<style scoped>
    .diagonalCross2 {
        background: linear-gradient(to top left, #fff calc(50% - 1px), black, #fff calc(50% + 1px));
    }
    td {
        height: 30px !important;
    }
    tr,
    td,
    th,
    table {
        font-size: 10px;
        border: 0.2px solid black;
        border-collapse: separate;
        font-family: "Times New Roman", Times, serif;
    }
    .table_container_data {
        display: flex;
    }
    .table_container_data table {
        border-collapse: separate;
        border-spacing: 0;
        border: none;
    }
    div {
        font-family: "Times New Roman", Times, serif;
    }

    @media print {
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        th {
            white-space: nowrap;
        }
        .grade-table {
            width: 93% !important;
        }
        .grade-table th {
            font-size: 11px !important;
        }
        .first-col {
            width: 10% !important;
            text-align: left;
            padding-left: 7px !important;
        }
        .blank-td {
            width: 2% !important;
        }
        .svg-content {
            padding-top: 5px !important;
            width: 30%;
        }
        .svg-content_crs {
            width: 80%;
        }
        @page {
            size: 12in 9in !important;
            font-family: "Times New Roman", Times, serif;
            margin: 0mm;
            font-weight: bolder !important;
        }
        .pagebreak {
            page-break-before: always;
            line-height: -50px !important;
        }
    }
    .stud_details2 {
        border-bottom: 1px solid black;
        height: 25px;
    }
</style>
